<template>
    <div class="dish-compare-table__box box">
        <table class="dish-compare-table__table dish-compare-table__table_striped dish-compare-table__table_hover">
            <caption class="dish-compare-table__caption">
                <template v-if="reportRow.link">
                    <router-link class="link link_red"
                        :to="reportRow.link.to"
                        :title="reportRow.link.title"
                    >
                        {{reportRow.caption}}
                    </router-link>
                </template>
                <template v-else>{{reportRow.caption}}</template>
            </caption>
            <col class="dish-compare-table__column"
                v-for="column in columns"
                :key="column.id"
                :class="`dish-compare-table__column_${column.id}`"
            >
            <thead>
                <tr class="dish-compare-table__row dish-compare-table__row_head">
                    <th class="dish-compare-table__cell dish-compare-table__cell_head" scope="col"
                        v-for="column in columns"
                        :key="column.id"
                    >
                        <div class="dish-compare-table__cell-content dish-compare-table__cell-content_columns"
                            :class="`dish-compare-table__cell-content_${column.alignment}`"
                        >
                            <span class="dish-compare-table__value">{{column.title}}</span>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr class="dish-compare-table__row dish-compare-table__row_body">
                    <td class="dish-compare-table__cell"
                        v-for="column in columns"
                        :key="column.id"
                        :class="{ 'dish-compare-table__cell_title': column.id === 'title' }"
                    >
                        <div class="dish-compare-table__cell-content dish-compare-table__cell-content_rows"
                            :class="`dish-compare-table__cell-content_${column.alignment}`"
                        >
                            <span class="dish-compare-table__value">
                                {{format(column, reportRow)}}
                            </span>
                            <difference v-if="column.difference && compareRow[column.id]"
                                 class="dish-compare-table__value"
                                :primaryValue="reportRow[column.id]"
                                :compareValue="compareRow[column.id]"
                                mode="percentage"
                                :good="column.difference.good"
                                filter="percentFloatFormat"
                            />
                            <percentage class="dish-compare-table__value"
                                v-if="column.id === 'cost'"
                                :part="reportRow.cost"
                                :whole="reportRow.discount"
                            />
                        </div>
                    </td>
                </tr>
                <tr class="dish-compare-table__row dish-compare-table__row_body">
                    <td class="dish-compare-table__cell"
                        v-for="column in columns"
                        :key="column.id"
                        :class="{ 'dish-compare-table__cell_title': column.id === 'title' }"
                    >
                        <div class="dish-compare-table__cell-content dish-compare-table__cell-content_rows"
                            :class="`dish-compare-table__cell-content_${column.alignment}`"
                        >
                            <template v-if="compareRow.hasOwnProperty(column.id)">
                                <span class="dish-compare-table__value">
                                    {{format(column, compareRow)}}
                                </span>
                                <percentage class="dish-compare-table__value"
                                    v-if="column.id === 'cost'"
                                    :part="compareRow.cost"
                                    :whole="compareRow.discount"
                                />
                            </template>
                            <span class="dish-compare-table__value" v-else>нет данных</span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import Difference from "@/components/Difference";
    import Percentage from "@/components/Percentage";

    export default {
        name: "DishCompareTable",
        components: {
            Difference,
            Percentage,
        },
        props: {
            columns: {
                type: Array,
                required: true
            },
            reportRow: {
                type: Object,
                required: true
            },
            compareRow: {
                type: Object,
                required: true
            }
        },
        methods: {
            format(column, row) {
                if (!this.$options.filters[column.filter]) {
                    return row[column.id];
                }

                return this.$options.filters[column.filter](row[column.id]);
            }
        },
    };
</script>

<style lang="scss">
    .dish-compare-table__box {
        padding: 16px;
        overflow-x: auto;
    }
    .dish-compare-table__table {
        width: 100%;
    }
    .dish-compare-table__caption {
        padding: 8px;
        font-size: 24px;
        font-weight: bold;
    }
    .dish-compare-table__row {
        &_body {
            .dish-compare-table__table_striped &:nth-of-type(odd) {
                background-color: $background-gray-primary;
            }

            .dish-compare-table__table_hover &:hover {
                background-color: $gray-form;
            }
        }

        &_pinned {
            background-color: $gray-form !important;
        }
    }
    .dish-compare-table__cell {
        font-size: 20px;
        padding: 12px 8px;

        &_head {
            padding: 8px;
            white-space: nowrap;
        }

        &_sortable {
            cursor: pointer;
        }

        &_title {
            font-weight: bold;
        }

        &_tar {
            text-align: right;
        }
    }
    .dish-compare-table__cell-content {
        display: grid;
        grid-gap: 5px;

        &_columns {
            grid-auto-flow: column;
            align-items: center;

            &.dish-compare-table__cell-content_left {
                justify-content: start;
            }

            &.dish-compare-table__cell-content_right {
                justify-content: end;
            }
        }

        &_rows {
            grid-auto-flow: row;

            &.dish-compare-table__cell-content_left {
                justify-items: start;
            }

            &.dish-compare-table__cell-content_right {
                justify-items: end;
            }
        }
    }
    .dish-compare-table__value {
        &_icon {
            width: 16px;
            height: 16px;
        }
    }
</style>
